export function formatDate(date: Date): string {
  const monthAndYear = date.toLocaleString('en-US', {
    month: 'short',
    year: 'numeric',
  });
  const day = date.getDate();
  return `${day} ${monthAndYear}`;
}
